module.exports = __webpack_public_path__ + "img/IT0000115084542.ee20c223.png";